import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from "@angular/core";
import { gridItem } from "src/app/models";
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';

@Component({
    selector: 'app-column-order',
    templateUrl: './column-order.component.html',
    styleUrls: ['./column-order.component.scss'],
    standalone: false
})
export class ColumnOrderComponent implements OnInit {
  @Input() public gridItem: gridItem;
  @Input() public columns: any[];
  @Output() public columnOrderEvent = new EventEmitter<string[]>();

  public selectedColumns: any[] = [];
  public orderedColumns: any[] = [];
  public defaultColumns: any[] = [];
  public useDefault: boolean = false;

  constructor() { }

  ngOnInit(): void {
    let columnsIndexes = [];
    let setupColumns = this.gridItem.setup.columns;
    for (let i = 0; i < setupColumns.length; i++) {
      let column = setupColumns[i];
      let columnInfo = this.columns.find(c => c.labelCode === column);
      this.selectedColumns.push({
        id: columnInfo.id,
        name: columnInfo.shortDescription,
        label: columnInfo.labelCode
      });

      this.orderedColumns.push({
        id: columnInfo.id,
        name: columnInfo.shortDescription,
        label: columnInfo.labelCode
      });
    }

    for (let i = 0; i < setupColumns.length; i++) {
      let column = setupColumns[i];
      let index = this.columns.indexOf(this.columns.find(c => c.labelCode === column));
      let columnInfo = this.columns[index];
      columnsIndexes.push({
        index: index,
        id: columnInfo.id,
        name: columnInfo.shortDescription,
        label: columnInfo.labelCode
      });
    }

    this.defaultColumns = columnsIndexes.sort((a, b) => { return a.index - b.index });
  }

  drop(event: CdkDragDrop<any[]>) {
    if (event.previousIndex == event.currentIndex) return;
    moveItemInArray(this.selectedColumns, event.previousIndex, event.currentIndex);
    moveItemInArray(this.orderedColumns, event.previousIndex, event.currentIndex);
    this.columnOrderEvent.emit(this.selectedColumns.map(sc => sc.label));
  }

  defaultOrder(event) {
    this.useDefault = event.checked;
    let setupColumns = this.useDefault ?
      this.defaultColumns.map(sc => sc.label) :
      this.selectedColumns.map(sc => sc.label);
    this.columnOrderEvent.emit(setupColumns);
  }
}